<template>
	<div id="program_applications" class="container text-center">
		<div class="w-full md:w-3/5 md:mx-auto">
			<h2>What To Expect From Your Lawn Care Program Applications</h2>
			<p>
				Properly caring for your lawn means being attentive to the season of the
				year and the climate in which you live. Every region comes with unique
				lawn care, fertilization and weed and pest control needs.
			</p>
		</div>
		<div class="lg:mx-16 hidden lg:block">
			<ClientOnly>
				<Carousel
					:items-to-show="2"
					:items-to-scroll="2"
					:wrapAround="true"
					snapAlign="start"
				>
					<Slide
						class=""
						v-for="(result, index) in sortedPreferredResults"
						:key="index"
					>
						<div class="mx-4">
							<div class="program-card">
								<div class="program-numbers">
									<span>{{ index + 1 }}</span> {{ result[0].ProgramTypeDetail }}
								</div>
								<img
									loading="lazy"
									:src="`${imageLocation}/lawn-program-applications/${result[0].ProgramTypeDetail.replace(' ', '_').toLowerCase()}.webp`"
									class="rounded w-full"
									alt="early spring"
								/>
								<div class="p-8 equalHeight_pa">
									<h3>
										{{ result[0].ProgramTypeDetail }} lawn care for {{ location }}
									</h3>
									<p>
										{{ result[0].ProgramTypeDesc }}
									</p>
								</div>
							</div>
						</div>
					</Slide>
					<template #addons>
						<Navigation />
					</template>
				</Carousel>
			</ClientOnly>
			<p class="mt-8">
				<NuxtLink to="/services/lawn-care-services/" class="button"
					>Explore our lawn care programs</NuxtLink
				>
			</p>
		</div>
		<div class="block lg:hidden mx-6">
			<ClientOnly>
				<Carousel
					:items-to-show="1"
					:items-to-scroll="1"
					:wrapAround="true"
				>
					<Slide
						class=""
						v-for="(result, index) in franchiseData.BranchLawnCarePgm.Preferred"
						:key="index"
					>
						<div>
							<div class="program-card">
								<div class="program-numbers">
									<span>{{ index }}</span> {{ result[0].ProgramTypeDetail }}
								</div>
								<img
									:src="`${imageLocation}/lawn-program-applications/${result[0].ProgramTypeDetail.replace(' ', '_').toLowerCase()}.webp`"
									class="rounded w-full"
									alt="early spring"
									loading="lazy"
								/>
								<div class="p-8 equalHeight_pa">
									<h3>
										{{ result[0].ProgramTypeDetail }} lawn care for {{ location }}
									</h3>
									<p>
										{{ result[0].ProgramTypeDesc }}
									</p>
								</div>
							</div>
						</div>
					</Slide>
					<template #addons>
						<Navigation />
					</template>
				</Carousel>
			</ClientOnly>
			<p class="mt-8">
				<NuxtLink to="/services/lawn-care-services/" class="button"
					>Explore our lawn care programs</NuxtLink
				>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useNuxtApp } from "#app";
import { Carousel, Slide, Navigation } from "vue3-carousel";

// Props
const props = defineProps({
	location: {
		type: String,
		default: "your area",
	},
	franchiseData: {
		type: Object,
		required: true,
	},
	perPage: {
		type: Number,
		default: 2,
	},
});

const { $config } = useNuxtApp();

const imageLocation = ref($config.public.sgCmsImage);

// Computed properties
const sortedPreferredResults = computed(() => {
	const sortedKeys = Object.keys(
		props.franchiseData.BranchLawnCarePgm.Preferred
	).sort((a, b) => {
		const numA = parseInt(a.substring(1), 10);
		const numB = parseInt(b.substring(1), 10);
		return numA - numB;
	});

	const sortedResults = sortedKeys.map(
		(key) => props.franchiseData.BranchLawnCarePgm.Preferred[key]
	);

	return sortedResults;
});

// Methods
const equalHeight_pa = (resize) => {
	var elements = document.getElementsByClassName("equalHeight_pa"),
		allHeights = [],
		i = 0;
	if (resize === true) {
		for (i = 0; i < elements.length; i++) {
			elements[i].style.height = "auto";
		}
	}
	for (i = 0; i < elements.length; i++) {
		var elementHeight = elements[i].clientHeight;
		allHeights.push(elementHeight);
	}
	for (i = 0; i < elements.length; i++) {
		elements[i].style.height = Math.max.apply(Math, allHeights) + "px";
		if (resize === false) {
			elements[i].className = elements[i].className + " show";
		}
	}
};

// Lifecycle hooks
onMounted(() => {
	setTimeout(() => {
		equalHeight_pa(true);
	}, 1000);
});
</script>
